import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc86264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "first" }, null, -1))
const _hoisted_3 = { class: "diagSwap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineTwo" }, [
  /*#__PURE__*/_createElementVNode("div", null, "中国儿童AD临床诊断标准"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("——“姚氏”标准 "),
    /*#__PURE__*/_createElementVNode("span", { class: "jiaobiao" }, "1")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineThree" }, "符合1+2+3即是AD", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineFore" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("瘙痒")
], -1))
const _hoisted_7 = { class: "bxs" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linefive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftfive" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3"),
    /*#__PURE__*/_createTextVNode("慢性或慢性复发性疾病")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "rightfive" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2"),
    /*#__PURE__*/_createTextVNode("典型的形态和部位 （屈侧皮炎）或不典型的形态 和部位同时伴发干皮症 ")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footred" }, "该患儿诊断为重度儿童期特应性皮炎合并细菌感染", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footDetail" }, [
  /*#__PURE__*/_createTextVNode(" AD 的诊断"),
  /*#__PURE__*/_createElementVNode("span", null, "主要依靠临床表现"),
  /*#__PURE__*/_createTextVNode("，实验室检查仅提供参考依据， 可表明患儿处于特应性状态，提示病情活动，或是给予存在相关疾病的提示"),
  /*#__PURE__*/_createElementVNode("span", { class: "jiaobiao" }, "2")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1.中华医学会皮肤性病学分会免疫学组,特应性皮炎协作研究中心. 中华皮肤科杂志,2020,53(2):81-88."),
  /*#__PURE__*/_createElementVNode("span", null, "2.中华医学会皮肤性病学分会儿童皮肤病学组.中华皮肤科杂志,2017,50(11):784-789.")
], -1))
const _hoisted_12 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_image, {
            width: "3.8rem",
            height: "3.12rem",
            src: require('../assets/diagbak.png')
          }, null, 8, ["src"])
        ]),
        _hoisted_8,
        _hoisted_9
      ]),
      _hoisted_10,
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_van_image, {
        onClick: $options.nexStep,
        width: "2.5733rem",
        height: "2.5733rem",
        src: require('../assets/jixu.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ])
  ], 64))
}